<template>
  <div>
    <!-- 制作轮播图弹窗 -->
    <el-dialog
      title="制作图片"
      top="2vh"
      width="1410px"
      class="swiper-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :visible="dialogShow"
      :before-close="handleClose"
    >
      <iframe
        class="bar-xkw"
        ref="barXkw"
        :src="iframeSrc"
        frameborder="0"
      ></iframe>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "ShopCenterAdminWebMSwiperDialog",

  data() {
    return {
      // dialogSwiperVisible: false,·
      iframeSrc: "//bar.xkw.com/specific?id=99", // 测试环境链接
    };
  },
  computed: {
    dialogShow() {
      if (this.$store.state.mDecoration.dialogType == "createSwiper") {
        return true;
      }
      return false;
    },
  },
  watch: {
    dialogShow: {
      handler(newValue) {
        // 如果是显示tab导航的简介弹窗 则回显简介内容
        if (
          newValue &&
          this.$store.state.mDecoration.dialogType == "createSwiper"
        ) {
          if (this.$refs.barXkw) this.$refs.barXkw.src = this.iframeSrc; // 刷新iframe
        }
      },
    },
  },
  mounted() {
    // 根据环境设置iframeSrc 正式环境链接
    if (process.env.NODE_ENV == "production") {
      this.iframeSrc = "//bar.xkw.com/specific?id=98";
    }
  },

  methods: {
    // 关闭弹窗
    handleClose(done) {
      // 更新数据到vuex中
      this.$store.commit("mDecoration/setDialogType", "");
      done();
    },
  },
};
</script>

<style lang="scss" scoped>
.swiper-dialog {
  ::v-deep .el-dialog {
    border-radius: 6px !important;
  }
  ::v-deep .el-dialog__body {
    padding: 0;
    background: #eceef5;
    border-radius: 6px !important;
    height: 750px;
  }
  .bar-xkw {
    width: 100%;
    // height: 100%;
    height: 750px;
  }
}
</style>
